<template>
  <div class="knowledge-scenes-list-body">
    <p>场景知识云为您找到相关结果约 {{ page.total }} 个</p>
    <div v-if="list&&list.length">
      <div
        class="knowledge-scenes-list"
        v-for="(item, index) in list"
        :key="index"
        @click="view(item.id)"
      >
        <p v-if="item.sceneNameTitle" v-html="item.sceneNameTitle"></p>
        <p v-else>{{ item.sceneName }}</p>
        <span v-if="item.descriptionInfo" v-html="item.descriptionInfo"></span>
        <span v-else v-html="item.description"></span>
        <div>
          <span>发布时间：{{ item.publishTime | moment("YYYY-MM-DD") }}</span>
          <span>场景来源：{{ item.sceneFrom }}</span>
        </div>
      </div>
      <div class="pagination-body">
        <a-pagination
          :total="page.total"
          :current="page.current"
          show-quick-jumper
          :show-total="(total) => `共 ${total} 项`"
          @change="pageChange"
        />
      </div>
    </div>
    <div v-else style="padding-top: 50px">
      <a-empty />
    </div>
  </div>
</template>

<script>
import { getSearchZsyList } from "@/api/zsy";

export default {
  props: ["search"],
  data() {
    return {
      list: [],
      searchVal: "",
      page: {
        total: 0,
        current: 1,
        size: 10
      }
    };
  },
  watch: {
    search: function(val) {
      this.searchVal = val;
      this.loadData();
    }
  },
  mounted() {
    this.searchVal = this.search;
    setTimeout(() => {
      this.loadData();
    }, 100);
  },
  methods: {
    loadData() {
      const { current, size } = this.page;
      let search = this.searchVal;
      let data = {
        sceneKeywords: search,
        searchType: "1"
      };
      getSearchZsyList({ current, size }, data).then((res) => {
        this.list = res.data.records;
        this.page.total = res.data.total;
        if (this.searchVal && this.list && this.list.length) {
          this.list = this.list.map((item) => {
            for (let key in item) {
              if (key === "description") {
                let replaceReg = new RegExp(search, "g"); // 匹配关键字正则
                let replaceString =
                  "<span style=\"color:#1ABC9C\">" + search + "</span>"; // 高亮替换v-html值
                item[key + "Info"] = item[key].replace(
                  replaceReg,
                  replaceString
                ); // 开始替换
              }
              if (key === "sceneName") {
                let replaceReg = new RegExp(search, "g"); // 匹配关键字正则
                let replaceString =
                  "<span style=\"color:#1ABC9C\">" + search + "</span>"; // 高亮替换v-html值
                item[key + "Title"] = item[key].replace(
                  replaceReg,
                  replaceString
                ); // 开始替换
              }
            }
            return item;
          });
        }
      });
    },
    pageChange(e) {
      this.page.current = e;
      this.loadData();
    },
    view(id) {
      let routeData = this.$router.resolve({
        path: "/homeKnowledge/scenesInfo",
        query: { id }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.knowledge-scenes-list-body {
  > p {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 12px;
    margin-bottom: 24px;
  }

  > div {
    background: #fff;
    padding: 0 24px 24px;

    .knowledge-scenes-list {
      padding: 24px 0;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;

      > p {
        font-size: 16px;
        margin-bottom: 20px;
        line-height: 16px;
      }

      > span {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 20px;
        display: block;
        max-height: 40px;
        color: #595959;
        overflow: hidden;
      }

      > div {
        display: flex;
        align-items: center;

        > span {
          margin-right: 40px;
          font-size: 12px;
          color: #8c8c8c;
          line-height: 12px;
          max-width: 500px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
